export default "__VITE_ASSET__ee5dee31__"